import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

const Leftbar = () => {
  const project = useSelector((state) => state.project.value)

  return (
    <Wrap color1 = {project.colors[0]} color2 = {project.colors[1]}>
      <p className = "sideCompanyName">{project.companyName}</p>
    </Wrap>
  )
}

export default Leftbar


const Wrap = styled.div`
  position: fixed;
  height: 100vh;
  padding: 0px;
  top: 0;
  left: 0px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  z-index: 11;
  align-items: center;
  

  @media (max-width: 800px){
    display: none;
  }



  p{

    width: 100vh;
    text-transform: uppercase;
    margin-left: 55px;
    position: fixed;
    transform: rotate(-90deg);
    text-align: center;
    font-size: 14px;

    pointer-events: none;
    color: ${(props) => props.color2};

  }

`
